import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import $ from "jquery";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { CountryDropdown } from "react-country-region-selector";
import LoadingSpinner from "../../utils/components/LoadingSpinner";
import { setAlert } from "../../../actions/alertActions";
import {
  getCountryName,
  getCountryCode,
  getPlug,
  compressImage,
} from "../../utils/Utils";

import "../../../styles/components/evs/modals/ActionOtherEV.scss";
import evsPlaceholder from "../../../styles/images/evsPlaceholder.svg";
import camera from "../../../styles/images/camera.svg";

class ActionOtherEV extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      isScrolled: false,

      evPicture: evsPlaceholder,
      types: [],

      type: "",
      plate: "",
      brand: "",
      model: "",
      battery: "",
      country: getCountryName(this.props.country) || "",

      plugs: getPlug("[all]").map((p) => Object.assign({}, p, { power: "" })),

      otherInfo: "",
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handlePickPlug = this.handleChangePlug.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchOtherEVTypes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.show &&
      this.props.mode === "add" &&
      prevProps.mode !== "add"
    ) {
      this.safeSetState({
        validated: false,
        isScrolled: false,
        evPicture: evsPlaceholder,
        type: "",
        plate: "",
        brand: "",
        model: "",
        battery: "",
        country: getCountryName(this.props.country) || "",
        plugs: getPlug("[all]").map((p) => Object.assign({}, p, { power: "" })),
        otherInfo: "",
      });
    }
    if (
      this.props.hasOwnProperty("selectedEV") &&
      this.props.selectedEV &&
      this.props.selectedEV.evType !== "car"
    ) {
      if (
        prevProps.selectedEV !== this.props.selectedEV ||
        prevProps.selectedEV.evId !== this.props.selectedEV.evId
      ) {
        const { selectedEV } = this.props;
        this.fetchOtherEVTypes(() => {
          let plugs = getPlug("[all]");
          selectedEV.evInfo.plugs.forEach((plug) => {
            const idx = plugs.findIndex((p) => p.name === plug.plugType);
            if (idx !== -1) {
              plugs[idx] = Object.assign({}, plugs[idx], {
                picked: true,
                power: plug.plugPower,
              });
            }
          });

          this.safeSetState({
            evPicture: selectedEV.imageContent,
            type: selectedEV.evType,
            plate: selectedEV.licensePlate,
            brand: selectedEV.brand,
            model: selectedEV.model,
            battery: selectedEV.evInfo.maxBatteryCapacity,
            country: selectedEV.country,
            plugs,
            otherInfo: selectedEV.otherInfo,
          });
        });
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchOtherEVTypes(callback) {
    axios
      .get("/api/private/otherEvs", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({ types: res.data }, callback);
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    const file = e.target.files && e.target.files[0];

    compressImage(file).then((evPicture) => {
      this.safeSetState({ evPicture });
    });
  }

  handleChangePlug(attr, plugIdx, e) {
    const plug = this.state.plugs[plugIdx];
    this.safeSetState({
      plugs: [
        ...this.state.plugs.slice(0, plugIdx),
        Object.assign({}, plug, {
          [attr]: attr === "power" ? e.target.value : !plug[attr],
        }),
        ...this.state.plugs.slice(plugIdx + 1),
      ],
    });
  }

  handleOnChange(e) {
    const { name, value } = e.target;
    this.safeSetState(
      {
        [name]: value,
      },
      () => {
        if (name === "type" && value === "otherEv")
          this.safeSetState({ plate: "" });
      }
    );
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (
        form.checkValidity() !== false &&
        this.state.plugs.filter((p) => p.picked && p.power !== "").length > 0
      ) {
        this.props.toggleLoadingActionCards(true);
        const { type, plate, brand, model, battery } = form.elements;
        this.props.mode === "add"
          ? this.props.onSubmit(
              this.state.evPicture !== evsPlaceholder
                ? this.state.evPicture
                : "",
              type.value,
              plate.value,
              brand.value,
              model.value,
              battery.value,
              this.state.country,
              this.state.plugs.filter((p) => p.picked),
              this.state.otherInfo
            )
          : this.props.onSubmit(
              this.props.selectedEV,
              this.state.evPicture !== evsPlaceholder
                ? this.state.evPicture
                : "",
              type.value,
              plate.value,
              brand.value,
              model.value,
              battery.value,
              this.state.country,
              this.state.plugs.filter((p) => p.picked),
              this.state.otherInfo
            );
      }
    });
  }

  resetState() {
    this.safeSetState({
      validated: false,
      isScrolled: false,
      evPicture: evsPlaceholder,
      type: "",
      plate: "",
      brand: "",
      model: "",
      battery: "",
      country: getCountryName(this.props.country) || "",

      plugs: getPlug("[all]").map((p) => Object.assign({}, p, { power: "" })),
      otherInfo: "",
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const shouldShowLicense = () => {
      if (this.state.type !== "" && this.state.types.length > 0) {
        const type = this.state.types.find((t) => t.evType === this.state.type);
        if (type) return type.showLicense;
      }
      return false;
    };

    return (
      <Modal
        id="addOtherEV"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate
              value={this.props.mode === "add" ? "evs_addEV" : "evs_editEV"}
            />
          </Modal.Title>
        </Modal.Header>
        <div
          className={
            "picture-picker-container " +
            (this.state.isScrolled ? "shadowed" : "")
          }
        >
          <input
            id="file-picker"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={this.handlePictureChange}
          />
          <button
            type="button"
            className="picture-picker"
            onClick={this.handlePickPicture}
          >
            <img
              id="picture"
              src={this.state.evPicture || evsPlaceholder}
              onError={(e) => (e.target.src = evsPlaceholder)}
              alt={
                this.state.evPicture !== evsPlaceholder
                  ? "EV picture"
                  : "placeholder"
              }
            />
            <img src={camera} className="camera" alt="" />
          </button>
        </div>
        <Modal.Body onScroll={this.handleScroll}>
          <Form
            id="add-other-ev-form"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleOnSubmit}
            className="ev-properties"
          >
            <Form.Group className="form-field type" controlId="evType">
              <Form.Label>
                <Translate value="evs_evType" />
              </Form.Label>
              <Form.Control
                as="select"
                name="type"
                value={this.state.type}
                onChange={this.handleOnChange}
                required
              >
                <option value="" disabled hidden>
                  {I18n.t("evs_evTypeSelect")}
                </option>
                {this.state.types.map((type) => (
                  <option key={type.evType} value={type.evType}>
                    {I18n.t(type.translationKey)}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className="form-field plate" controlId="evPlate">
              <Form.Label>
                <Translate value="evs_plate" />
              </Form.Label>
              <Form.Control
                type="text"
                name="plate"
                value={this.state.plate}
                onChange={this.handleOnChange}
                required={shouldShowLicense()}
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidPlate" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field brand" controlId="evBrand">
              <Form.Label>
                <Translate value="evs_brand" />
              </Form.Label>
              <Form.Control
                type="text"
                name="brand"
                value={this.state.brand}
                onChange={this.handleOnChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidBrand" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field model" controlId="evModel">
              <Form.Label>
                <Translate value="evs_model" />
              </Form.Label>
              <Form.Control
                type="text"
                name="model"
                value={this.state.model}
                onChange={this.handleOnChange}
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidModel" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field battery" controlId="evBattery">
              <Form.Label>
                <Translate value="evs_battery" />
              </Form.Label>
              <Form.Control
                type="number"
                name="battery"
                value={this.state.battery}
                onChange={(e) => {
                  const onlyNums = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 3);
                  this.setState({ battery: onlyNums });
                }}
                onKeyDown={(e) => {
                  if (["-", "+", "e", "."].includes(e.key)) e.preventDefault();
                }}
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidBattery" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field country" controlId="evCountry">
              <Form.Label>
                <Translate value="evs_country" />
              </Form.Label>
              <Form.Control
                as={CountryDropdown}
                value={this.state.country}
                onChange={(country) => this.safeSetState({ country })}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="form-field plugs" controlId="evPlugs">
              <Form.Label>
                <Translate value="evs_plugType" />
              </Form.Label>
              <Form.Control
                as="div"
                className="plugs-container"
                isInvalid={
                  this.state.validated &&
                  this.state.plugs.filter((p) => p.picked).length === 0
                }
                required
              >
                {this.state.plugs.map((plug, idx) => {
                  return (
                    <div
                      key={plug.name}
                      id={plug.name}
                      className="plug-container"
                    >
                      <div
                        className="plug"
                        onClick={(e) => this.handleChangePlug("picked", idx, e)}
                      >
                        <img
                          src={plug.picked ? plug.selected : plug.plug}
                          alt={plug.name}
                        />
                        <label>{plug.name}</label>
                      </div>
                      {plug.picked && (
                        <Form.Control
                          type="number"
                          className="power-input"
                          placeholder="kW"
                          value={plug.power}
                          min="0"
                          step="0.1"
                          onChange={(e) =>
                            this.handleChangePlug("power", idx, e)
                          }
                          onKeyDown={(e) =>
                            (e.key === "e" || e.key === "+" || e.key === "-") &&
                            e.preventDefault()
                          }
                          required
                        />
                      )}
                    </div>
                  );
                })}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                <Translate value="addEV_invalidPlug" />
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="form-field otherInfo" controlId="otherInfo">
              <Form.Label>
                <Translate value="myEvs_additionalInfo" />
              </Form.Label>
              <textarea
                name="otherInfo"
                placeholder={I18n.t("myEvs_typeHere")}
                value={this.state.otherInfo}
                onChange={this.handleOnChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {this.props.loading === true ? (
            <LoadingSpinner />
          ) : (
            <button type="submit" form="add-other-ev-form">
              <Translate
                value={this.props.mode === "add" ? "evs_addEV" : "evs_editEV"}
              />
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  country: state.account.accountData.country,
});

export default connect(mapStateToProps, { setAlert })(ActionOtherEV);
